export default "__VITE_ASSET__BWDrUNmF__"